<script lang="ts" setup>
import { useAuthentication } from '@ilteducation/ilt-auth';
import { useRoute } from 'vue-router';
import config from '@/config/ConfigProvider';

const serviceName = config.value('serviceName');
const clientId = config.value('authClientId');

const authRedirectBasePath = '/login';

const route = useRoute();

const auth = useAuthentication();

const loginLink = auth.createLoginLink({
  appName: serviceName,
  clientId,
  hint: route.params.loginHint as string | undefined,
  redirectBasePath: authRedirectBasePath,
  additionalQuery: route.query,
});

window.location.replace(loginLink);
</script>

<template>
  <div></div>
</template>

<style scoped></style>
